<script>
import DataTablePublic from '@/components/common/DataTablePublic'
import {
  PublicHeader,
  Breadcrumb,
  CardsFiltro,
  FaixaComparacao
} from '@/components'
import request from '@/request'
import { formatObjectToQueryString } from '@/utils/strings'

export default {
  name: 'dados_index',
  components: {
    DataTablePublic,
    PublicHeader,
    Breadcrumb,
    CardsFiltro,
    FaixaComparacao
  },
  data() {
    return {
      imgUrl: this.$root.$data.imgUrl,
      title: 'Dados',
      filtros: {
        tags: [],
        secretarias: [],
        autarquias: [],
        eixos: [],
        metas: [],
        termo_pesquisa: {
          codigo: '',
          ativo: true
        }
      },
      model: {
        columnID: 'DAD_IDDADO',
        columns: [
          {
            name: 'nome',
            title: 'Nome',
            dataClass: 'align-middle',
            filterable: true
          },
          {
            name: 'fonte',
            title: 'Fonte',
            dataClass: 'align-middle',
            filterable: true
          },
          {
            name: '__slot:icon',
            title: 'Favoritos',
            titleClass: 'text-center',
            dataClass: 'align-middle text-center'
          },
          {
            name: '__slot:column',
            title: 'Metas ODS',
            titleClass: 'text-center',
            dataClass: 'align-middle text-center'
          },
          {
            name: '__slot:actions',
            title: 'Ações',
            titleClass: 'text-center col-md-3',
            dataClass: 'text-center'
          }
        ]
      },
      filtrosParametro: this.$router.history.current.query,
      addDadoState: {}
    }
  },
  created() {
    this.formatFiltroParam()
  },
  beforeMount() {
    this.loadFiltros()
  },
  computed: {
    idsArray() {
      return Object.keys(this.addDadoState).filter(
        codigo => this.addDadoState[codigo]
      )
    },
    hasFilterEnable() {
      var me = this
      return (
        Object.keys(me.filtros).find(tipo => {
          return me.hasFilterEnableOf(tipo)
        }) !== undefined
      )
    },
    hasFilterDisable() {
      var me = this
      return (
        Object.keys(me.filtros).find(tipo => {
          return me.hasFilterDisableOf(tipo)
        }) !== undefined
      )
    },
    activeFilterList() {
      if (this.filtrosParametro.metas.length) {
        const filter = item => {
          return this.filtrosParametro.metas.includes(item.codigo)
        }

        return this.filtros.metas.filter(filter)
      }

      return []
    },
    filtersAvailable() {
      if (this.filtrosParametro.metas.length) {
        const filter = item => {
          return !this.filtrosParametro.metas.includes(item.codigo)
        }

        return this.filtros.metas.filter(filter)
      }

      return this.filtros.metas
    },
    selectedCount() {
      return Object.values(this.addDadoState).filter(value => value).length
    }
  },
  methods: {
    retornarAtivos(array) {
      const retorno = [...array].filter(item => {
        return item.ativo === true
      })

      return retorno
    },
    permitirComparativo(item) {
      if (item.tipoValor === 'T') {
        return false
      }

      return true
    },
    salvarFavorito(codigo) {
      let objeto = JSON.parse(localStorage.getItem('pmsdadosabertos'))

      if (objeto) {
        let index = objeto.favoritos.indexOf(codigo)
        if (index === -1) {
          objeto.favoritos.push(codigo)
        } else {
          objeto.favoritos.splice(index, 1)
        }
      } else {
        objeto = { favoritos: [codigo] }
      }

      localStorage.setItem('pmsdadosabertos', JSON.stringify(objeto))
      this.$refs.dt.refresh()
      this.$toastr.s('Favoritos salvos com sucesso.')
    },
    classeFavoritos(codigo) {
      let objeto = JSON.parse(localStorage.getItem('pmsdadosabertos'))

      if (objeto && objeto.favoritos.indexOf(codigo) > -1) {
        return ['fas', 'star']
      }

      return ['far', 'star']
    },
    classeSelecionados(codigo) {
      return this.addDadoState[codigo] ? ['btn-remove'] : ['btn-add']
    },
    formatFiltroParam() {
      if (Object.keys(this.filtrosParametro).length) {
        Object.keys(this.filtrosParametro).forEach(k => {
          if (!Array.isArray(this.filtrosParametro[k])) {
            this.filtrosParametro[k] = [
              parseInt(this.filtrosParametro[k]) || this.filtrosParametro[k]
            ]
          } else {
            this.filtrosParametro[k] = this.filtrosParametro[k]
          }
        })

        return
      }

      this.filtrosParametro = { metas: [] }
    },
    clearFiltros() {
      Object.keys(this.filtros).forEach(tipo => {
        this.filtros[tipo] = []
      })
    },
    loadFiltros() {
      request.get(
        'listar-filtros',
        // 'listar-filtros?' + formatObjectToQueryString(this.filtrosParametro),
        response => {
          this.clearFiltros()
          Object.keys(response).forEach(tipo => {
            this.filtroAddRange(tipo, response[tipo])
          })
        },
        response => {
          console.log(response)
        }
      )
    },
    add(tipo, filtro) {
      if (tipo !== 'termo_pesquisa') {
        filtro.ativo = true
      } else {
        this.filtrosParametro[tipo] = null
      }
      
      if (this.filtrosParametro[tipo]) {
        this.filtrosParametro[tipo].push(filtro.codigo)
      } else {
        this.filtrosParametro[tipo] = [filtro.codigo]
      }

      window.history.pushState(
        null,
        null,
        '?' + formatObjectToQueryString(this.filtrosParametro)
      )
      this.$nextTick(() => {
        this.loadFiltros()
        this.$refs.dt.refresh()
      })
    },
    remove(tipo, filtro) {
      if (Array.isArray(filtro)) {
        delete this.filtrosParametro[tipo]
        filtro.forEach(i => {
          i.ativo = false
        })
      } else {
        var index = this.filtrosParametro[tipo].indexOf(filtro.codigo)
        this.filtrosParametro[tipo].splice(index, 1)
        filtro.ativo = false
      }

      if (this.hasfiltrosParametro()) {
        window.history.pushState(
          null,
          null,
          '?' + formatObjectToQueryString(this.filtrosParametro)
        )
      } else {
        window.history.pushState(
          null,
          null,
          window.location.href.split('?').shift()
        )
      }

      this.$nextTick(() => {
        this.loadFiltros()
        this.$refs.dt.refresh()
      })
    },
    hasfiltrosParametro() {
      var keys = Object.keys(this.filtrosParametro)
      var foundFilter = false
      var c = 0
      while (!foundFilter && c < keys.length) {
        foundFilter = this.filtrosParametro[keys[c++]].length > 0
      }
      return foundFilter
    },
    isActiveFilter(tipo, codigo) {
      return (
        this.filtrosParametro.hasOwnProperty(tipo) &&
        this.filtrosParametro[tipo].find(i => i === codigo) !== undefined
      )
    },
    filtroAddRange(tipo, filtros) {
      filtros.forEach(i => {
        i.ativo = this.isActiveFilter(tipo, i.codigo)
        this.filtros[tipo].push(i)
        if (tipo === 'secretarias') {
          i.descricao = i.sigla
        }
      })
    },
    hasFilterDisableOf(tipo) {
      if (Array.isArray(this.filtros[tipo])) {
        return this.filtros[tipo].filter(i => !i.ativo).length > 0
      }
    },
    hasFilterEnableOf(tipo) {
      if (Array.isArray(this.filtros[tipo])) {
        return this.filtros[tipo].filter(i => i.ativo).length > 0
      }
    },
    addFilter(value) {
      const { codigo } = value
      this.filtrosParametro.metas.push(codigo)
      this.$refs.dt.refresh()
    },
    removeFilter(value) {
      const { codigo } = value
      const filter = item => {
        return item !== codigo
      }
      this.filtrosParametro.metas = this.filtrosParametro.metas.filter(filter)
      this.$refs.dt.refresh()
    },
    toggleAddDado(codigo) {
      if (this.addDadoState[codigo] === undefined) {
        this.$set(this.addDadoState, codigo, true)
      } else {
        this.addDadoState[codigo] = !this.addDadoState[codigo]
      }
    },
    getPopoverContent(codigo) {
      return this.addDadoState[codigo]
        ? 'Clique para remover o dado da comparação'
        : 'Clique para adicionar o dado para comparação'
    }
  }
}
</script>

<template>
  <div class="row">
    <PublicHeader title="Listagem de dados">
      <div class="col-xs-12">
        <p>
          Abaixo você encontra a listagem de dados, baseada no filtro
          selecionado.
        </p>
      </div>
    </PublicHeader>
    <div class="container">
      <Breadcrumb :links="[{ label: 'Lista de dados' }]" />
      <div class="row" v-if="filtersAvailable.length">
        <div class="col-xs-12">
          <CardsFiltro
            :title="'Filtros disponíveis'"
            :metas="filtersAvailable"
            @click="addFilter"
          />
        </div>
      </div>
      <div class="row" v-if="filtrosParametro.metas.length">
        <div class="col-xs-12">
          <CardsFiltro
            :title="'Filtros ativos'"
            :metas="activeFilterList"
            @click="removeFilter"
          />
        </div>
      </div>
      <div class="row">
        <div class="col col-xs-10">
          <h3>Digite sua pesquisa</h3>
        </div>
        <div class="col-xs-12">
          <div class="input-group filtro-pesquisa">
            <input
              type="text"
              class="form-control"
              v-model="filtros.termo_pesquisa.codigo"
              placeholder="Filtrar pesquisa..."
            />
            <span class="input-group-btn">
              <button
                class="btn btn-default"
                @click="add('termo_pesquisa', filtros.termo_pesquisa)"
              >
                <font-awesome-icon :icon="'search'" />
              </button>
            </span>
          </div>
        </div>
      </div>
      <div class="row align-items-center">
        <div class="col col-xs-10">
          <h3>Lista de Dados</h3>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <div class="table-responsive">
            <data-table-public
              ref="dt"
              :has-auth="false"
              title="lista de dados"
              api-url="listar-dados"
              :show-empty="true"
              :fields="model.columns"
              :append-params="filtrosParametro"
            >
              <template slot="columncustom" slot-scope="props">
                <img
                  v-for="meta in props.rowData.metas"
                  :key="`minimeta-${meta.codigo}`"
                  :src="`${imgUrl}${meta.imagem_url}`"
                  :title="meta.titulo"
                  :data-toggle="'popover'"
                  :data-content="meta.objetivo"
                  :data-placement="'top'"
                  :data-trigger="'hover'"
                  :alt="
                    `imagem representando a meta ${meta.titulo} para filtrar a lista`
                  "
                  class="mini-meta"
                />
              </template>
              <template slot="icon" slot-scope="props">
                <a role="button" @click="salvarFavorito(props.rowData.codigo)">
                  <font-awesome-icon
                    :icon="classeFavoritos(props.rowData.codigo)"
                  ></font-awesome-icon>
                </a>
              </template>
              <template slot="rowrender" slot-scope="props">
                <router-link
                  title="Listar valores"
                  class="btn btn-primary"
                  :to="{
                    name: 'public_detalhes',
                    params: { id: props.rowData.codigo }, 
                    query: { origem: 'dados' }
                  }"
                >
                  <font-awesome-icon :icon="'list-ol'" />
                </router-link>
                <button
                  v-if="permitirComparativo(props.rowData)"
                  :class="['btn', classeSelecionados(props.rowData.codigo)]"
                  @click="toggleAddDado(props.rowData.codigo)"
                  title="Dado Comparativo"
                  :data-toggle="'popover'"
                  :data-content="getPopoverContent(props.rowData.codigo)"
                  :data-placement="'top'"
                  :data-trigger="'hover'"
                >
                  <font-awesome-icon
                    :icon="addDadoState[props.rowData.codigo] ? 'minus' : 'plus'"
                  />
                </button>
              </template>
            </data-table-public>
          </div>
        </div>
      </div>
    </div>
    <FaixaComparacao :idsArray="idsArray" :query="'dados'" />
  </div>
</template>

<style scoped>
.mini-meta {
  height: 50px;
  width: 50px;
}
.filtro-pesquisa input,
.filtro-pesquisa button {
  height: 50px;
  margin-bottom: 30px;
}
.filtro-pesquisa i {
  font-size: 1.3em;
}
.list-group {
  margin: 0;
  list-style-type: none;
}
.list-group-item {
  border-radius: 20px;
  margin-bottom: 10px;
}
.list-group-item.flex {
  float: left;
  margin-right: 10px;
}
.list-group-item button {
  margin-left: 5px;
}
.list-group-item.remove-all {
  border: none;
  margin-top: 3px;
  font-weight: bold;
  font-size: 0.95em;
  background-color: transparent;
}
.btn-add {
  background: transparent;
  color: #468b35;
  border: 2px solid;
  border-radius: 6px;
}
.btn-add:hover,
.btn-add:focus {
  background: transparent;
  border: 2px solid;
  color: #a1be4d;
  text-transform: uppercase;
  box-shadow: none;
}
.btn-remove {
  text-shadow: 0 1px 0 #266c16;
  background: #468c36;
  color: #dae8d7;
  box-shadow: none;
  border-radius: 6px;
}
.btn-remove:focus,
.btn-remove:hover {
  background-color: #a1be4d;
  background-position: 0 -15px;
  color: #fff;
  border-radius: 6px;
}
.align-items-center {
  display: flex;
  align-items: center;
}
.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
</style>



// WEBPACK FOOTER //
// src/views/public/dados/index.vue